export default function parseDateSafe(date: string): Date {
    const parsed = Date.parse(date);
    if (!isNaN(parsed)) {
        return new Date(parsed);
    }

    return new Date(Date.parse(date.replace(/-/g, '/').replace(/[a-z]+/gi, ' ')));
}